export function pluralize(count = 0, noun: string, suffix = 's') {
  return `${noun}${count !== 1 ? suffix : ''}`;
}
;
